<template>
  <el-select
    v-model="value"
    :clearable="clearable"
    :collapse-tags="collapseTags"
    :filter-method="filterMethod"
    :filterable="filterable"
    :loading="loading"
    :multiple="multiple"
    :no-match-text="noMatchText"
    :placeholder="placeholder"
    :remote="remote"
    :remote-method="remoteMethod"
    :size="size"
    :value-key="valueKey"
    @change="change"
    @clear="clear"
    @visible-change="visibleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label | filterTestCorp | filterExtent"
      :value="item.value"
    />
  </el-select>
</template>

<script>
export default {
  name: 'nf-select',
  props: {
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    formData: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: '',
    },
    // 是否多选 默认 false
    multiple: {
      type: Boolean,
      default: false,
    },
    // 多选时是否将选中值按文字的形式展示
    collapseTags: {
      type: Boolean,
      default: true,
    },
    // value-key 作为 value 唯一标识的键名，绑定值为对象类型时必填
    valueKey: {
      type: String,
      default: '',
    },
    // 输入框尺寸  默认 small  medium/small/mini
    size: {
      type: String,
      default: 'mini',
    },
    // 是否清空选项 默认false
    clearable: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
    // 是否可搜索 默认false
    filterable: {
      type: Boolean,
      default: false,
    },
    noMatchText: {
      type: String,
      default: '无匹配信息',
    },
    // 是否为远程搜索 默认false
    remote: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      return this.$store.state[this.storeModelName][this.formData.state];
    },
  },
  watch: {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    // 选中值发生变化时触发
    change(e) {
      this.value = e;
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: e,
      });
      this.$store.commit(`${this.storeModelName}/updatePostParams`, { page: 1, size: 20 });
      //   this.$store.dispatch(`${this.storeModelName}/getList`);
    },
    // 下拉框出现/隐藏时触发 出现则为 true，隐藏则为 false
    visibleChange(val) {
      if (val && this.options.length === 0 && this.formData.path) {
        this.filterMethod('');
      }
    },
    // 自定义搜索方法
    async filterMethod(val) {
      this.loading = true;
      await this.$store.dispatch(`${this.formData.path}`, val);
      this.loading = false;
    },
    // 远程搜索方法
    async remoteMethod(val) {
      this.loading = true;
      await this.$store.dispatch(`${this.formData.path}`, val);
      this.loading = false;
    },
    clear() {
      this.value = '';
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: '',
      });
      this.$store.dispatch(`${this.storeModelName}/getList`);
    },
  },
};
</script>
